import React from "react";
import NotificationAlert from "react-notification-alert";
import isEmpty from "lodash/isEmpty";
import Validator from "validator";
import { connect } from "react-redux";
import { PulseLoader } from "react-spinners";
import { forgotPassword } from "../../modules/actions/authActions";
import ReCAPTCHA from "react-google-recaptcha";

function validateInput(data) {
  let errors = {};
  if (Validator.isEmpty(data.email)) {
    errors.email = "Email field is required";
  }

  if (!Validator.isEmail(data.email)) {
    errors.email = "Enter valid Email ID";
  }
  return {
    errors,
    isValid: isEmpty(errors)
  };
}

class ForgotPasswordForm extends React.Component {
  recaptchaRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      subject: "",
      message: "",
      errors: {},
      successMsg: "",
      isLoading: false,
      invalid: false,
      isHuman: false,
      humanKey: null
    };
  }

  _onChange = event => {
    const field = event.target.name;
    const value = event.target.value;
    this.setState({ [field]: value });
  };

  handleForgotPassword = event => {
    event.preventDefault();
    if (this.isValid()) {
      const { email } = this.state;

      const emailPayload = {
        email: email,
        humanKey: this.state.humanKey
      };
      this.setState({ errors: {}, isLoading: true });
      this.props
        .forgotPassword(emailPayload)
        .then(data => {
          console.log(data);
          if (data.status) {
            this.setState({ isLoading: false });
            this.refs.notify.notificationAlert({
              place: "tc",
              message: (
                <div>
                  <div>
                    <b>{data.message}</b>
                  </div>
                </div>
              ),
              type: "success",
              icon: "now-ui-icons ui-1_bell-53",
              autoDismiss: 7
            });
          } else {
            this.setState({ isLoading: false });
            this.refs.notify.notificationAlert({
              place: "tc",
              message: (
                <div>
                  <div>
                    <b>{data.message}</b>
                  </div>
                </div>
              ),
              type: "danger",
              icon: "now-ui-icons ui-1_bell-53",
              autoDismiss: 7
            });
          }
          this.recaptchaRef.current.reset();
          this.setState({isHuman: false, humanKey: null});
        })
        .catch(error => {
          this.setState({ isLoading: false });
          this.refs.notify.notificationAlert({
            place: "tc",
            message: (
              <div>
                <div>
                  <b>{error.response.data.message}</b>
                </div>
              </div>
            ),
            type: "danger",
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
          });
          this.recaptchaRef.current.reset();
          this.setState({isHuman: false, humanKey: null});
        });
    }
  };

  isValid() {
    const { errors, isValid } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }

  componentDidMount() {
    this.attachKeyupListenerToInputElements();
  }

  attachKeyupListenerToInputElements = () => {
    let self = this;
    let inputs = document.querySelectorAll("input");
    for (let i = 0; i < inputs.length; i += 1) {
      inputs[i].addEventListener("keyup", keyupHandler);
    }

    function keyupHandler(event) {
      event.preventDefault();
      if (event.keyCode === 13) {
        self.handleForgotPassword(event);
      }
    }
  };

  // ReCAPTCHA Client Side
  verifyCaptcha = (res) => {
    if(res) {
      this.setState({ isHuman: true, humanKey: res })
    }
  }

  // ReCAPTCHA Expired
  expireCaptcha = () => {
    this.setState({ isHuman: false, humanKey: null })
  }

  render() {
    const { errors, email } = this.state;
    return (
      <section className="section bg-gradient text-white">
        <div className="container">
          <div className="row">
            <PulseLoader
              className="sweet-loading"
              sizeUnit={"px"}
              size={20}
              color={"#123abc"}
              loading={this.state.isLoading}
            />
            <div className="col-lg-12">
              <div className="text-center">
                <h2 className="font-weight-bold">FORGOT YOUR PASSWORD?</h2>
                <small>
                  Please provide the email address that you used when you signed
                  up for your MightyWifi account.
                  <br />
                  We will send you an email that will allow you to reset your
                  password.
                </small>

                <div className="row">
                  <NotificationAlert ref="notify" />
                  <div className="col-lg-3" />
                  <div className="col-lg-6">
                    <div className="form-group mt-3">
                      <input
                        name="email"
                        className="form-control"
                        placeholder="Enter Email Address"
                        onChange={this._onChange}
                        value={email}
                      />
                      {errors.email && (
                        <span className="error-color-dash">{errors.email}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3" />
                </div>

                <div style={{ clear: "both", height: "10px" }} />

                <div className="row">
                  <div className="col-lg-3" />
                  <div className="col-lg-6">
                    <ReCAPTCHA
                        ref={this.recaptchaRef}
                        sitekey={'6LdUIyweAAAAAOs44Nk0ouoOHyz1YlbNMCJuBHfo'}
                        // render="explicit"
                        onChange={this.verifyCaptcha}
                        onExpired={this.expireCaptcha}
                    />
                  </div>
                </div>

                <div style={{ clear: "both", height: "40px" }} />

                <a
                  href="javascript:void(0)"
                  onClick={this.handleForgotPassword}
                  className="btn btn-outline-white"
                >
                  SUBMIT
                </a>

                <div style={{ clear: "both", height: "100px" }} />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}
export default connect(
  mapStateToProps,
  {
    forgotPassword
  }
)(ForgotPasswordForm);



// WEBPACK FOOTER //
// ./src/pages/forgotPassword/ForgotPasswordForm.js